module.exports = __webpack_public_path__ + "static/media/sd02.72b64dd1.png";